/* eslint-disable */

// if outdated browser, load polyfills, otherwise skip for modern browsers
var loadPolyfills = function(srcUrl) {
    var js = document.createElement('script');
    if(localStorage.getItem('stlPolyfills') == null || (Date.now() - localStorage.getItem('stlPolyfillsDate') > 8 * 60 * 60 * 1000)) {
        var jsReq;
        jsReq=new XMLHttpRequest();
        jsReq.open('GET',window.location.protocol+"//"+window.location.host+srcUrl, false);
        jsReq.onload = function () {
            if (jsReq.readyState === 4) {
                if (jsReq.status === 200 || jsReq.status === 0) {
                    js.text = jsReq.responseText;
                    localStorage.setItem('stlPolyfills', btoa(js.text));
                    localStorage.setItem('stlPolyfillsDate', Date.now())
                }
            }
        }
        jsReq.send();
    } else {
        js.text = atob(localStorage.getItem('stlPolyfills'));
        localStorage.setItem('stlPolyfillsDate', Date.now())
    }
    document.head.appendChild(js);
}

if(typeof fetch === "undefined") loadPolyfills('/a/97798');

// add both click and keydown event listener
function a11yClick(e){if("click"===e.type)return!0;if("keydown"!==e.type)return!1;var r=e.charCode||e.keyCode;return 32===r||13===r||void 0}

var sessionStorage_transfer = function(event) {
    if(!event) { event = window.event; } // ie suq
    if(!event.newValue) return;          // do nothing if no value to work with
    if (event.key == 'getSessionStorage') {
        // another tab asked for the sessionStorage -> send it
        localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
        // the other tab should now have it, so we're done with it.
        localStorage.removeItem('sessionStorage'); // <- could do short timeout as well.
    } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
        // another tab sent data <- get it
        var data = JSON.parse(event.newValue);
        for (var key in data) {
            sessionStorage.setItem(key, data[key]);
        }
    }
};
// listen for changes to localStorage
if(window.addEventListener) {
    window.addEventListener("storage", sessionStorage_transfer, false);
} else {
    window.attachEvent("onstorage", sessionStorage_transfer);
};
// Ask other tabs for session storage (this is ONLY to trigger event)
if (!sessionStorage.length) {
    localStorage.setItem('getSessionStorage', 'stl');
    localStorage.removeItem('getSessionStorage', 'stl');
};

// get previously submitted form values
var sLoadTime = Date.now();
var sFirst = sessionStorage.getItem('stlFirst');
var sLast = sessionStorage.getItem('stlLast');
var sEmail = sessionStorage.getItem('stlEmail');
var sGuides = sessionStorage.getItem('stlGuides');
var sDiff = sessionStorage.getItem('stlDiff');
var sSubmit = sessionStorage.getItem('stlFormSubmit');

"use strict";
let _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj
    } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
    },
    globalFunctions = {};
! function (a, b, c) {
    "use strict";

    function d(a, b) {
        this._defaults = e, this.element = a, this.setOptions(b), this.init()
    }
    let e = {
        tagName: "a",
        newLine: "\n",
        target: "_blank",
        linkClass: null,
        linkClasses: [],
        linkAttributes: null
    };
    d.prototype = {
        constructor: d,
        init: function init() {
            1 === this.element.nodeType ? d.linkifyNode.call(this, this.element) : this.element = d.linkify.call(this, this.element.toString())
        },
        setOptions: function setOptions(a) {
            this.settings = d.extendSettings(a, this.settings)
        },
        toString: function toString() {
            return this.element.toString()
        }
    }, d.extendSettings = function (a, b) {
        for (let c in b = b || {}, e) b[c] || (b[c] = e[c]);
        for (c in a) b[c] = a[c];
        return b
    }, d.linkMatch = new RegExp("(\\s|[^a-zA-Z0-9.\\+_\\/\"\\>\\-]|^)(?:([a-zA-Z0-9\\+_\\-]+(?:\\.[a-zA-Z0-9\\+_\\-]+)*@)?(http:\\/\\/|https:\\/\\/|ftp:\\/\\/)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9_%\\-_+]*\\.)+))((?:com|ca|co|edu|gov|net|org|dev|biz|cat|int|pro|tel|mil|aero|asia|coop|info|jobs|mobi|museum|post|travel|local|[a-zA-Z]{2}))((?::\\d{1,5}))?((?:[\\/|\\?](?:[\\-a-zA-Z0-9_%#*&+=~!?,;:.\\/]*)*)[\\-\\/a-zA-Z0-9_%#*&+=~]|\\/?)?)([^a-zA-Z0-9\\+_\\/\"\\<\\-]|$)", "g"), d.emailLinkMatch = /(<[a-zA-Z]+ href=\")(http:\/\/)([a-zA-Z0-9\+_\-]+(?:\.[a-zA-Z0-9\+_\-]+)*@)/g, d.linkify = function (a, b) {
        let c, e, f, g = [];
        for (c in this.constructor === d && this.settings ? (e = this.settings, b && (e = d.extendSettings(b, e))) : e = d.extendSettings(b), f = e.linkClass ? e.linkClass.split(/\s+/) : [], f.push.apply(f, e.linkClasses), a = a.replace(/</g, "&lt;").replace(/(\s)/g, "$1$1"), g.push("$1<" + e.tagName, "href=\"http://$2$4$5$6$7\""), g.push("class=\"linkified" + (0 < f.length ? " " + f.join(" ") : "") + "\""), e.target && g.push("target=\"" + e.target + "\""), e.linkAttributes) g.push([c, "=\"", e.linkAttributes[c].replace(/\"/g, "&quot;").replace(/\$/g, "&#36;"), "\""].join(""));
        return g.push(">$2$3$4$5$6$7</" + e.tagName + ">$8"), a = a.replace(d.linkMatch, g.join(" ")), a = a.replace(d.emailLinkMatch, "$1mailto:$3"), a = a.replace(/(\s){2}/g, "$1"), a = a.replace(/\n/g, e.newLine)
    }, d.linkifyNode = function (a) {
        let b, e, f, g, h;
        if (a && "object" == ("undefined" == typeof a ? "undefined" : _typeof(a)) && 1 === a.nodeType && "style" !== a.nodeName.toLowerCase() && "script" !== a.nodeName.toLowerCase() && "noscript" !== a.nodeName.toLowerCase() && "a" !== a.tagName.toLowerCase() && !/[^\s]linkified[\s$]/.test(a.className)) {
            for (b = [], g = d._dummyElement || c.createElement("div"), e = a.firstChild, f = a.childElementCount; e;) {
                if (3 === e.nodeType) {
                    for (; g.firstChild;) g.removeChild(g.firstChild);
                    for (g.innerHTML = d.linkify.call(this, e.textContent || e.innerText || e.nodeValue), b.push.apply(b, g.childNodes); g.firstChild;) g.removeChild(g.firstChild)
                } else 1 === e.nodeType ? b.push(d.linkifyNode(e)) : b.push(e);
                e = e.nextSibling
            }
            for (; a.firstChild;) a.removeChild(a.firstChild);
            for (h = 0; h < b.length; h++) a.appendChild(b[h])
        }
        return a
    }, d._dummyElement = c.createElement("div"), a.fn.linkify = function (b) {
        return this.each(function () {
            let c;
            (c = a.data(this, "plugin-linkify")) ? (c.setOptions(b), c.init()) : a.data(this, "plugin-linkify", new d(this, b))
        })
    }, a.fn.linkify.Constructor = d, a(b).on("load", function () {
        a("[data-linkify]").each(function () {
            let b, c = a(this),
                d = c.attr("data-linkify"),
                e = {
                    tagName: c.attr("data-linkify-tagname"),
                    newLine: c.attr("data-linkify-newline"),
                    target: c.attr("data-linkify-target"),
                    linkClass: c.attr("data-linkify-linkclass")
                };
            for (let f in e) "undefined" == typeof e[f] && delete e[f];
            b = "this" === d ? c : c.find(d), b.linkify(e)
        })
    }), a("body").on("click", ".linkified", function () {
        let c = a(this),
            d = c.attr("href"),
            e = /^mailto:/i.test(d),
            f = c.attr("target");
        return e ? b.location.href = d : b.open(d, f), !1
    })
}(jQuery, window, document);


/* eslint-enable */
/* eslint no-unused-vars: 0 */
/* eslint no-dupe-keys: 0 */
/* global jQuery Stelter s orgId*/

if (!window.Stelter) {
    window.Stelter = {}
    window.Stelter.log = window.log = []
}

window.loading = windowName => {
    window[windowName] = window.open('about:blank', windowName + Date.now())
    window[windowName].document.write('<!DOCTYPE html><html><head><meta charset="utf-8"><title>Loading</title><meta name="viewport" content="width=device-width,initial-scale=1"></head><body><style>.loaderContainer{position:absolute;top:0;bottom:0;right:0;left:0;background-color:#fff;z-index:10}.loaderContainer .loader{border:16px solid #ddd;border-top:16px solid #3498db;border-radius:50%;width:120px;height:120px;animation:spin 2s linear infinite;position:absolute;left:0;top:0;margin:auto;right:0;bottom:200px;z-index:20}@keyframes spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}</style><div class="loaderContainer"><div class="loader"></div></div></body></html>')
}

if(!document.getElementsByTagName('html')[0].classList.contains(window.serverIs)) {
    document.getElementsByTagName('html')[0].classList.add(window.serverIs)
}

function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.MaxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0))
}

// check for valid email address
function isEmail(email) {
    let re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i
    return re.test(email)
}

//converts all static email addresses into hyperlinked email addresses
function emailize() {
    let all = document.getElementsByTagName('*')
    let tagNames = ['BODY', 'HTML', 'SCRIPT', 'A', 'LINK', 'TITLE', 'META', 'NOSCRIPT', 'FORM', 'INPUT']
    let regEx = /[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\.[a-zA-Z]{2,4}/
    for (let i = 0, max = all.length; i < max; i++) {
        if (tagNames.indexOf(all[i].tagName) < 0 && (typeof all[i].textContent != 'undefined' || jQuery.trim(all[i].textContent) != '')) {
            let match = all[i].textContent.match(regEx)
            if (match != null && all[i].innerHTML.search('mailto:' + match[0]) < 0) {

                let hyperlinkEmail = '<a href=\'mailto:' + match[0] + '\'>' + match[0] + '</a>'
                all[i].innerHTML = all[i].innerHTML.replace(regEx, hyperlinkEmail)
            }
        }
    }
}

function uberLoadDomains(url) {
    var rawFile = new XMLHttpRequest();
    rawFile.onload = function () {
        if (rawFile.readyState === 4) {
            if (rawFile.status === 200 || rawFile.status === 0) {
                var domainString = rawFile.responseText;
                var domainList = domainString.split('\n');
                var disclaimerCGAText = '<p class="ebro-form-disclaimer"><small>*Figures cited in this document’s examples are for hypothetical purposes only and are subject to change.</small></p>';
                if (domainList.indexOf(window.location.host) == -1) {
                    [].slice.call(document.querySelectorAll('#brochureform')).forEach(function(element){
                        element.insertAdjacentHTML('beforeend', disclaimerCGAText)
                    })
                    if (document.querySelector('#DCGAnextpage[value*="interactive.legacybrochure.com"]') !== null) {
                        document.querySelector('#DCGAbrochureform').insertAdjacentHTML('beforeend', disclaimerCGAText)
                    }
                }
                else {
                    return false;
                }
            } else {
                console.error(rawFile.statusText);
            }
        }
    };
    rawFile.onerror = function () { console.error(rawFile.statusText) };
    rawFile.open('GET', url, true);
    rawFile.send(null);
}

function interactiveBrochuresUpdate() {
    if ((document.querySelector('body.charitable-gift-annuities') !== null || document.querySelector('body#charitable-gift-annuities-page') !== null) && window.location.host.indexOf('ingeniuxondemand.com') == -1 && document.querySelector('#nextpage[value*="interactive.legacybrochure.com"]') !== null) {
        uberLoadDomains('/documents/stelter/interactive-brochures-updated.txt');
    }
}

function addCGAClass() {
    if (document.querySelector('.cga-article') !== null) {
        document.getElementsByTagName('body')[0].classList.add('cga-page')
    }
}

// Remove empty tags
function removeEmpties() {
    jQuery('h2,h3').filter(function () {
        return jQuery(this).text().trim().length == 0
    }).remove()
    if (jQuery('.stl_ContactWebsite a').is(':empty') === true) {
        jQuery('.stl_ContactWebsite a:empty').parents('.stl_ContactWebsite').remove()
    }
}
removeEmpties()

function replaceAllInstancesText(oldText, newText, selector){
    selector = typeof selector !== 'undefined' ? selector : '*';
    [].slice
        .call(document.querySelectorAll(selector))
        .filter(function (ele) { return ['META', 'BASE', 'LINK', 'SCRIPT', 'IMG', 'STYLE', 'PATH', 'path', 'HTML', 'BODY'].includes(ele.nodeName) == false })
        .filter(function (ele) { return ele.innerHTML.includes(oldText) })
        .forEach(function (ele) {
            [].slice.call(ele.childNodes).filter(function(node){return node.nodeName == '#text'}).forEach(function(node){
                node.textContent = node.textContent.replace(new RegExp(oldText,'gi'), newText)
            })
        })
}

function sentenceCase(string, orgname, short, clientExceptions) {
    let change = string
        .toLowerCase()
        // eslint-disable-next-line no-useless-escape
        .split(/([\?\.\!])+/g)
        .map(section => {
            let precedingWhiteSpace = section.length - section.replace(/^\s+/, '').length
            return ' '.repeat(precedingWhiteSpace) + section.charAt(precedingWhiteSpace).toUpperCase() + section.slice(precedingWhiteSpace + 1)
        })
        .join('')

    // This must go first of all the special cases because it deals with an edge case of the regex splitting on periods PS 05/17/2018
    change.indexOf('vs.') != -1 ? change = change.split('vs.').map((x, index) => index == 1 ? x.toLowerCase() : x).join('vs.') : null
    // capitalize orgname
    try {
        change.indexOf(orgname.toLowerCase()) != -1 ? change = change.replace(orgname.toLowerCase(), orgname) : null
    } catch (err) {
        Stelter.log.push('Did you forget to include @[orgname]?')
    }
    try {
        change.indexOf(short.toLowerCase()) != -1 ? change = change.replace(short.toLowerCase(), short) : null
    } catch (err) {
        Stelter.log.push('Did you forget to include @[short]?')
    }
    change.indexOf(' i ') != -1 ? change = change.replace(' i ', ' I ') : null
    change.indexOf('i’m') != -1 ? change = change.replace('i’m', 'I’m') : null
    change.indexOf('i\'m') != -1 ? change = change.replace('i\'m', 'I’m') : null
    change.indexOf(' ira ') != -1 ? change = change.replace(' ira ', ' IRA ') : null
    change.indexOf(' ira') != -1 ? change = change.replace(' ira', ' IRA') : null
    change.indexOf('Ira ') != -1 ? change = change.replace('Ira ', 'IRA ') : null
    change.indexOf(' diy ') != -1 ? change = change.replace(' diy ', ' DIY ') : null
    change.indexOf(' cga ') != -1 ? change = change.replace(' cga ', ' CGA ') : null
    change.indexOf('Cgas') != -1 ? change = change.replace('Cgas', 'CGAs') : null
    change.indexOf(' daf ') != -1 ? change = change.replace(' daf ',' DAF ') : null
    change.indexOf('Daf ') != -1 ? change = change.replace('Daf ','DAF ') : null
    change.indexOf('(no ') != -1 ? change = change.replace('(no ', '(No ') : null
    change.indexOf('warren buffett') != -1 ? change = change.replace('warren buffett', 'Warren Buffett') : null
    change.indexOf('social security') != -1 ? change = change.replace('social security', 'Social Security') : null
    change.indexOf('Social security') != -1 ? change = change.replace('Social security', 'Social Security') : null
    change.indexOf('medicare') != -1 ? change = change.replace('medicare', 'Medicare') : null
    change.indexOf('cares act') != -1 ? change = change.replace('cares act', 'CARES Act') : null
    Stelter.log.push(typeof clientExceptions)
    if (typeof clientExceptions === 'string') {
        change.indexOf(clientExceptions.toLowerCase()) != -1 ? change = change.replace(clientExceptions.toLowerCase(), clientExceptions) : null
    } else if (Array.isArray(clientExceptions)) {
        clientExceptions.forEach(function (item) {
            change.indexOf(item.toLowerCase()) != -1 ? change = change.replace(item.toLowerCase(), item) : null
        })
    }
    return change
}

// check for form sessionStorage values, set them on submit if they don't exist
function standardFormsSetSession(formId) {
    var gateForm = document.getElementById(formId);
    var tierArray = siteControlTier.split(",").map(tier => tier.trim());
    var sdsArray = ["Standard","Plus","SDS Guides"];
    if(sdsArray.some(tier => tierArray.includes(tier))) {
        var formName = gateForm.getAttribute('name');
        var subTime = Date.now();
        var subDiff = subTime - sLoadTime;
        if(subDiff < 5000) {
            return false;
        }
        else {
            var fName = gateForm.elements.namedItem('first') !== null ? gateForm.elements.namedItem('first').value : gateForm.elements.namedItem('fname') !== null ? gateForm.elements.namedItem('fname').value : "";
            var lName = gateForm.elements.namedItem('last') !== null ? gateForm.elements.namedItem('last').value : gateForm.elements.namedItem('lname') !== null ? gateForm.elements.namedItem('lname').value : "";
            var email = gateForm.elements.namedItem('email') !== null ? gateForm.elements.namedItem('email').value : gateForm.elements.namedItem('Email Address') !== null ? gateForm.elements.namedItem('Email Address').value : "";
            
            // set the guide id based on the specific form
            var guideId;
            if(gateForm.elements.namedItem('eBrochureId') !== null) {
                guideId = gateForm.elements.namedItem('eBrochureId').value;
            } else if (formName == 'PEPCForm'){
                guideId = 'Personal Estate Planning Kit';
            } else {
                guideId = "";
            }

            if(!sFirst || !sLast || !sEmail){
                sessionStorage.setItem('stlFirst',fName);
                sessionStorage.setItem('stlLast',lName);
                sessionStorage.setItem('stlEmail',email);
            }
            if(!sGuides){
                sessionStorage.setItem('stlGuides',guideId);
            } else {
                if(sGuides.indexOf(guideId) == -1) {
                    sessionStorage.setItem('stlGuides',sGuides + ", " + guideId);
                }
            }
            sessionStorage.setItem('stlDiff', subDiff);
            sessionStorage.setItem('stlFormSubmit',subTime);
            localStorage.setItem('stlLocalStorageTime',Date.now());

            return true;
        }

    } else {
        return true;
    }
}

function validateBrochureForm() {
    let brochureForm = document.forms['brochureform'];
    let fName = jQuery.trim(document.forms['brochureform']['first'].value)
    let lName = jQuery.trim(document.forms['brochureform']['last'].value)
    let email = jQuery.trim(document.forms['brochureform']['email'].value)
    let checkpoint = function () {
        if (document.forms['brochureform']['honeypot']) return jQuery.trim(document.forms['brochureform']['honeypot'].value)
        if (document.forms['brochureform']['ebroCheckpoint']) return jQuery.trim(document.forms['brochureform']['ebroCheckpoint'].value)
    }

    if ('' != checkpoint()) {
        //spam bot filled in hidden field, bypass form submission
        jQuery.magnificPopup.close()
        return false
    } else if (fName != '' && lName != '' && email != '') {
        if (!isEmail(email)) {
            alert('Please enter a valid email address')
            return false
        } else {
            jQuery.magnificPopup.close()
            // Set session values. If form submitted too quickly, returns false.
            return standardFormsSetSession(brochureForm.id)
        }
    } else {
        alert('Please fill your first name, last name and email address')
        return false
    }
}

function validatePEPCForm() {
    let pepcForm = document.forms['PEPCForm'];
    let fName = jQuery.trim(document.forms['PEPCForm']['first'].value)
    let lName = jQuery.trim(document.forms['PEPCForm']['last'].value)
    let email = jQuery.trim(document.forms['PEPCForm']['email'].value)
    let checkpoint = function () {
        if (document.forms['PEPCForm']['honeypot']) return jQuery.trim(document.forms['PEPCForm']['honeypot'].value)
        if (document.forms['PEPCForm']['pepcCheckpoint']) return jQuery.trim(document.forms['PEPCForm']['pepcCheckpoint'].value)
    }

    if ('' != checkpoint()) {
        //spam bot filled in hidden field, bypass form submission
        jQuery.magnificPopup.close()
        return false

    } else if (fName != '' && lName != '' && email != '') {
        if (!isEmail(email)) {
            alert('Please enter a valid email address')
            return false
        } else {
            jQuery.magnificPopup.close()
            // Set session values. If form submitted too quickly, returns false.
            return standardFormsSetSession(pepcForm.id)
        }
    } else {
        alert('Please fill your first name, last name and email address')
        return false
    }
}

var dcgaValidated = false;
function validateDcgaForm() {
    // Adjust DCGA nextpage url if it links to the new digital guide 
    if (jQuery('#DCGAnextpage').length > 0 && !dcgaValidated) {
        try {
            if (jQuery('#DCGAnextpage').val().indexOf('deferred-gift-annuities-guide') >= 0) {
                if (useRewrites == "False") {
                    var DCGAnextpage = jQuery('#DCGAnextpage'); //store for reference
                    var value = DCGAnextpage.val(); //store for reference
                    var host = value.indexOf("ingeniuxondemand.com") == -1 ? "https://" + window.location.hostname : "";
                    var leadingSlash = value.startsWith('/') ? '' : '/';
                    var htmlEbro = value.indexOf("ebr=") > -1;
                    var globalGuide =  value.indexOf("sitecontrol") == -1 && !htmlEbro ? "?sitecontrol=" + pageId : "";
                
                    dcgaValidated = true;
                    // If we are in preview, need to include "dsspreview" in the href
                    if (serverIs == "preview") {
                        DCGAnextpage.val(host + "/dsspreview" + leadingSlash + value + globalGuide);
                    }
                    else {
                        DCGAnextpage.val(host + leadingSlash + value + globalGuide);                                                                            
                    }
                }
            }
        }
        catch (err) {
            console.log("Error setting DCGA brochure nextpage | " + err);
        }
    }
    
    let brochureForm = document.forms['DCGAbrochureform'];
    let fName = jQuery.trim(document.forms['DCGAbrochureform']['first'].value)
    let lName = jQuery.trim(document.forms['DCGAbrochureform']['last'].value)
    let email = jQuery.trim(document.forms['DCGAbrochureform']['email'].value)
    let checkpoint = function () {
        if (document.forms['DCGAbrochureform']['honeypot']) return jQuery.trim(document.forms['DCGAbrochureform']['honeypot'].value)
        if (document.forms['DCGAbrochureform']['dcgaCheckpoint']) return jQuery.trim(document.forms['DCGAbrochureform']['dcgaCheckpoint'].value)
    }

    if ('' != checkpoint()) {
        //spam bot filled in hidden field, bypass form submission
        jQuery.magnificPopup.close()
        return false
    } else if (fName != '' && lName != '' && email != '') {
        if (!isEmail(email)) {
            alert('Please enter a valid email address')
            return false
        } else {
            jQuery.magnificPopup.close()
            if(!document.forms['DCGAbrochureform'].querySelector("#dcgaReCaptcha")) document.forms['DCGAbrochureform'].action = '../../../action/ebrosendemail.cshtml';
            // Set session values. If form submitted too quickly, returns false.
            return standardFormsSetSession(brochureForm.id)
        }
    } else {
        alert('Please fill your first name, last name and email address')
        return false
    }
}

//Avoid using strings that contain html special characters like &nbsp as this will most likely result in no matches
let safeSearch = function (elementTag, text) {
    let search = document.evaluate('//' + elementTag + '[contains(., \'' + text + '\')]', document, null, XPathResult.ANY_TYPE, null)

    let searchArray = []
    let tester = ''
    // eslint-disable-next-line no-constant-condition
    while (true) {
        tester = search.iterateNext()
        if (tester) {
            searchArray.push(tester)
        } else {
            break
        }
    }
    return searchArray
}

let deviceAgent = navigator.userAgent.toLowerCase()
//this letiable is set to null if the device is not iphone, ipod or ipad
let isiOS = deviceAgent.match(/(iphone|ipod|ipad)/)
let isZiflow = window.parent !== window && (document.referrer.indexOf('ziflow') > -1 || (typeof window.location.ancestorOrigins !== 'undefined' && typeof window.location.ancestorOrigins[0] !== 'undefined' && window.location.ancestorOrigins[0].indexOf('ziflow') > -1))

jQuery(function () {
	
	// Adobe Launch check
    window.isAdobeLaunch = (typeof _satellite !== "undefined");
    window.isNoAnalytics = (typeof window.isNoAnalytics !== 'undefined' && window.isNoAnalytics === true) || document.cookie.indexOf('Stl_NoAnalytics') > -1;
	
    // replace GI 1.0 links/iframes
    window.giftIllustratorTwoRedirect = () => {
        var orgIdValue = window.orgId || '';
        const valuesToSearchFor = ['web.giftillustrator.com/Calculator/Production/cga', 'web.giftillustrator.com/Calculator/Production/secondary2', 'web.giftillustrator.com/Calculator/Production/secondary1', 'web.giftillustrator.com/Calculator/Production/og', 'web.giftillustrator.com/Calculator/Production/home', 'web.giftillustrator.com/Calculator/Production/rle', 'web.giftillustrator.com/Calculator/Production/dcga', 'web.giftillustrator.com/Calculator/Production/bs', 'web.giftillustrator.com/Calculator/Production/crut']

        const curriedLinkLookup = (value) => {
            return Array.from(document.querySelectorAll(`a[href*="${value}"],iframe[src*="${value}"]`))
        }

        valuesToSearchFor.forEach(value => {
            if(curriedLinkLookup(value).length > 0 ){
                curriedLinkLookup(value).forEach(link => {
                    if (orgIdValue === '') {
                        if (link.tagName === 'A' && link.href.toLowerCase().includes('orgid=')) {
                            orgIdValue = link.href.toLowerCase().split('orgid=')[1].split('&')[0]
                        }
                        if (link.tagName === 'IFRAME' && link.src.toLowerCase().includes('orgid=')) {
                            orgIdValue = link.src.toLowerCase().split('orgid=')[1].split('&')[0]
                        }
                    }

                    orgIdValue = orgIdValue.toUpperCase()

                    const valueToNewURL = {
                        /* eslint-disable */
                        'web.giftillustrator.com/Calculator/Production/cga': 'https://calculator.giftillustrator.com/' + orgIdValue + '/gift-annuity',
                        'web.giftillustrator.com/Calculator/Production/secondary2': 'https://calculator.giftillustrator.com/' + orgIdValue + '/lead-trust',
                        'web.giftillustrator.com/Calculator/Production/secondary1': 'https://calculator.giftillustrator.com/' + orgIdValue + '/charitable-remainder-trust',
                        'web.giftillustrator.com/Calculator/Production/og': 'https://calculator.giftillustrator.com/' + orgIdValue + '/outright-gift',
                        'web.giftillustrator.com/Calculator/Production/home': 'https://calculator.giftillustrator.com/' + orgIdValue,
                        'web.giftillustrator.com/Calculator/Production/rle': 'https://calculator.giftillustrator.com/' + orgIdValue + '/retained-life-estate',
                        'web.giftillustrator.com/Calculator/Production/dcga': 'https://calculator.giftillustrator.com/' + orgIdValue + '/gift-annuity',
                        'web.giftillustrator.com/Calculator/Production/bs': 'https://calculator.giftillustrator.com/' + orgIdValue + '/bargain-sale',
                        'web.giftillustrator.com/Calculator/Production/crut': 'https://calculator.giftillustrator.com/' + orgIdValue + '/charitable-remainder-trust'
                        /* eslint-enable */
                    }

                    var newUrl = valueToNewURL[value];
                    if (link.tagName === 'A') link.href = newUrl
                    if (link.tagName === 'IFRAME') link.src = newUrl
                })
            }
        })
    }

    window.giftIllustratorTwoRedirect()

    // External link clicks
    if (isAdobeLaunch) {
        var subIdValue = typeof stlDigitalData !== 'undefined' && typeof stlDigitalData.user !== 'undefined' ? stlDigitalData.user.profile.subId : '';
        var pageLinks = document.querySelectorAll('a');
        pageLinks.forEach(function(link){
            var host = window.location.hostname;

            if(link.firstChild === link.lastChild && link.textContent.indexOf('"') > -1) {
                // double quotes in link text will break tracking, so replace them with curly quotes
                var content = link.textContent;
                content = content.replace(/"(?=\w|$^")/g, "“");
                content = content.replace(/"/g, "”");
                link.textContent = content;
            }

            if(link.href.length > 0 
                && link.href.indexOf(host) === -1 
                && link.href.indexOf('mailto:') === -1 
                && link.href.indexOf('tel:') === -1
                && link.href.indexOf('#') === -1
                && link.href.indexOf('javascript:') === -1
                && link.href.indexOf('giftillustrator.com') === -1
                && (typeof link.target !== 'undefined' && link.target !== '_blank')
            ) {
                link.addEventListener('click',function(){
                    _satellite.track("site.exit",{"site":link.href});
                });
                link.addEventListener('keydown',function(){
                    _satellite.track("site.exit",{"site":link.href});
                });
            }
            
            if(link.href.indexOf('calculator.giftillustrator.com') > -1) {
                var giUrl = link.href;
                
                if(giUrl.indexOf('subid=') === -1) {
                    document.cookie.split('; ').forEach(function(c) {
                        if(subIdValue === '' && c.startsWith('Stl_SubId')) {
                            subIdValue = c.split('=')[1]
                        }
                    })
                    if(subIdValue !== '') {
                        giUrl = giUrl.indexOf('?') > -1 ? giUrl + '&subid=' + subIdValue : giUrl + '?subid=' + subIdValue 
                    }
                }

                var mcmid = typeof _satellite !== 'undefined' && typeof _satellite.getVisitorId()._fields !== 'undefined' ? _satellite.getVisitorId()._fields.MCMID : '';

                if (giUrl.indexOf('adobe_mc') === -1 && mcmid !== '') {
                    giUrl = giUrl.indexOf('?') > -1 ? giUrl + '&adobe_mc=MCMID=' + mcmid : giUrl + '?adobe_mc=MCMID=' + mcmid 
                }

                link.href = giUrl;
            }

            if(link.href.indexOf('mailto:') > -1) {
                // configured in launch
            }
            if(link.href.indexOf('tel:') > -1) {
                // configured in launch
            }
        });

        var giFrames = document.querySelectorAll('iframe[src*="calculator.giftillustrator.com"]');
        giFrames.forEach(function(frame) {
            var giUrl = frame.src;

            if(giUrl.indexOf('subid=') === -1) {
                document.cookie.split('; ').forEach(function(c) {
                    if(subIdValue === '' && c.startsWith('Stl_SubId')) {
                        subIdValue = c.split('=')[1]
                    }
                })
                if(subIdValue !== '') {
                    giUrl = giUrl.indexOf('?') > -1 ? giUrl + '&subid=' + subIdValue : giUrl + '?subid=' + subIdValue 
                }
            }

            var mcmid = typeof _satellite !== 'undefined' && typeof _satellite.getVisitorId()._fields !== 'undefined' ? _satellite.getVisitorId()._fields.MCMID : '';

            if (giUrl.indexOf('adobe_mc') === -1 && mcmid !== '') {
                giUrl = giUrl.indexOf('?') > -1 ? giUrl + '&adobe_mc=MCMID=' + mcmid : giUrl + '?adobe_mc=MCMID=' + mcmid 
            }

            frame.src = giUrl;
        })
    } else if (isNoAnalytics) {
        var noAnalyticsGiLinks = document.querySelectorAll('a[href*="calculator.giftillustrator.com"]');
        noAnalyticsGiLinks.forEach(function(link){
            var giUrl = link.href;
            if (giUrl.indexOf('stl_analytics=') === -1) {
                giUrl = giUrl.indexOf('?') > -1 ? giUrl + '&stl_analytics=false' : giUrl + '?stl_analytics=false'
            }
            link.href = giUrl;
        });

        var noAnalyticsGiFrames = document.querySelectorAll('iframe[src*="calculator.giftillustrator.com"]');
        noAnalyticsGiFrames.forEach(function(frame) {
            var giUrl = frame.src;
            if (giUrl.indexOf('stl_analytics=') === -1) {
                giUrl = giUrl.indexOf('?') > -1 ? giUrl + '&stl_analytics=false' : giUrl + '?stl_analytics=false'
            }
            frame.src = giUrl;
        })
    }
	
    // consent notice and policy functions
    var displayConsent = function () {
        window.consentPop = localStorage.getItem('stlConsentPop');
        // check if the consent popup has been displayed
        if(!consentPop){
            var site = window.location.hostname;
            var siteControlParam = site.indexOf('ingeniuxondemand.com') > -1 ? "?sitecontrol=" + pageId : "";
            var consentWrapper = '<div id="stl-cookie-consent" role="dialog" aria-live="assertive" aria-describedby="stl-consent-desc" class="stl-consent-dialog stl-consent-show"></div>';
            document.body.insertAdjacentHTML('afterbegin',consentWrapper);
            var ccDialog = document.getElementById('stl-cookie-consent');
            if(ccDialog !== null)  {
                var consentContent = '<div class="stl-consent-wrapper"><p id="stl-consent-desc" class="stl-consent-message" tabindex="0">By continuing to access this website, you agree to our use of cookies, which help us understand who visits our website and how they use it. Read our <a class="stl-consent-link" href="/privacy-policy'+siteControlParam+'">privacy notice</a> for further&nbsp;details.</p><span role="button" aria-label="close popup and accept cookies" tabindex="0" class="stl-consent-close stl-consent-allow">&times;</span></div>';
                ccDialog.insertAdjacentHTML('beforeend',consentContent);
                // notice has been displayed
                localStorage.setItem('stlConsentPop','Displayed');
                // if (isAdobeLaunch) {
                //     _satellite.track("site_tool.interaction",{"toolName":site+": Cookie Notice Displayed"});
                // } 
                
                var trkNoticePolicyLink = function (e) {
                    if(a11yClick(e)) {
                        // user clicked to learn more
                        if (isAdobeLaunch) {
                            _satellite.track("site_tool.interaction",{"toolName":site+": Cookie Notice Policy Link"});
                        }
                    }
                }
                var trkNoticeCloseLink = function (e) {
                    if(a11yClick(e)) {
                        if(localStorage.getItem('dnt') !== null) localStorage.removeItem('dnt');
                        ccDialog.classList.remove('stl-consent-show');
                        // user clicked close
                        if (isAdobeLaunch) {
                            _satellite.track("site_tool.interaction",{"toolName":site+": Cookie Notice Close"});
                        }
                    }
                }

                ccDialog.querySelector('.stl-consent-link').addEventListener('click',trkNoticePolicyLink,false);
                ccDialog.querySelector('.stl-consent-link').addEventListener('keydown',trkNoticePolicyLink,false);
                ccDialog.querySelector('.stl-consent-allow').addEventListener('click',trkNoticeCloseLink,false);     
                ccDialog.querySelector('.stl-consent-allow').addEventListener('keydown',trkNoticeCloseLink,false);     
            }
        }

        if(document.querySelector('.stl-copyright') !== null && document.querySelectorAll('.stl-copyright .stl-policy-links a').length === 0) {
            document.querySelector('.stl-copyright').insertAdjacentHTML('beforeend',`<span class="stl-policy-links" style="display: none;"><a href="privacy-policy">Privacy Policy</a> | <a href="cookie-policy">Cookie Policy</a></span>`);
        }
    }
    var showSpecificPolicyInfo = function () {
        // depending on the client site, there will be different cookie information to display on the cookie notice page
        var cookiePage = document.querySelector('.syndicated.cookie-policy-copy');
        if(cookiePage !== null){
            // detect google analytics
            if(typeof ga === 'function' || typeof gtag === 'function') cookiePage.querySelector('.specific-cookie-notice[data-cookieName="GoogleAnalytics"]').classList.add('show');
            // detect capture
            if(typeof _cbe === 'function') cookiePage.querySelector('.specific-cookie-notice[data-cookieName="Capture"]').classList.add('show');
            // detect facebook pixel
            if(typeof fbq === 'function') cookiePage.querySelector('.specific-cookie-notice[data-cookieName="FacebookPixel"]').classList.add('show');
            // detect twitter remarketing
            if(typeof twq === 'function') cookiePage.querySelector('.specific-cookie-notice[data-cookieName="Twitter"]').classList.add('show');
            // detect others
            
            // remove rest
            var naCookies = document.querySelectorAll('.specific-cookie-notice:not(.show)');
            naCookies.forEach(function(section){
                section.remove();
            })

            if(document.querySelectorAll('.cookie-section-clients .specific-cookie-notice.show').length > 0) {
                document.querySelector('.cookie-section-clients').classList.remove('hide')
            } else {
                document.querySelector('.cookie-section-clients').remove()
            }
        }
    }

    var policyCallback = function () {
        if(typeof showConsent !== "undefined" && useRewrites == "True" && !isNoAnalytics) {
            displayConsent();
        } else {
            if(document.querySelectorAll('.stl-policy-links').length) {
                document.querySelectorAll('.stl-policy-links').forEach(el => el.remove())
            }
        }
        showSpecificPolicyInfo();
    }
    if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)) {
        policyCallback();
    } else {
        document.addEventListener("DOMContentLoaded", policyCallback);
    }

    if(document.querySelectorAll('.stl-policy-links a, .stl-policy-engaged-link').length > 0 && useRewrites == "False"){
        document.querySelectorAll('.stl-policy-links a, .stl-policy-engaged-link').forEach(function(link){
            var linkLocation = link.classList.contains("stl-policy-engaged-link") ? "Policy Page Engaged" : "Disclaimer";
            if(useRewrites == "False"){
                link.href = link.href + "?sitecontrol=" + pageId;
            }
            var trkPolicyEngagedLinks = function (e) {
                if(a11yClick(e)) {
                    // user clicked policy link in copy
                    if (isAdobeLaunch) {
                        _satellite.track("site_tool.interaction",{"toolName": window.location.hostname + ": Policy Link - " + linkLocation});
                    } 
                }
            }
            link.addEventListener('click',trkPolicyEngagedLinks,false);
            link.addEventListener('keydown',trkPolicyEngagedLinks,false);
        })
    }

    var displayCARES = function () {
        if(window.localStorage.getItem(orgId + 'caresNotice') !== null) window.localStorage.removeItem(orgId + 'caresNotice');
        var caresRequest = new XMLHttpRequest()
        var caresMessage = "";
        caresRequest.open('GET', window.location.protocol+"//"+window.location.host+'/cares-act-popup?clear=true', true)
        caresRequest.responseType = 'document'
        caresRequest.overrideMimeType('text/html')
        caresRequest.onload = () => {
            if (caresRequest.readyState === caresRequest.DONE) {
                if (caresRequest.status === 200) {
                    var content = caresRequest.responseXML;
                    caresMessage = content.getElementById('cares-act-popup-copy').innerHTML;
                    
                    var caresNoticeHTML = '<style>#caresNotice a{color:#fff !important; text-decoration:underline !important;}#caresNotice a:hover, #caresNotice a:focus{text-decoration:none !important;}.d-flex {display: -webkit-box !important;display: flex !important}.flex-justify-between {-webkit-box-pack: justify !important;justify-content: space-between !important}.flex-items-center {-webkit-box-align: center !important;align-items: center !important}.mx-auto {margin-right: auto !important;margin-left: auto !important}.d-none {display: none !important}.d-sm-inline-block {display: inline-block !important}.text-white {color: #fff !important;}.f5 {font-size: 14px !important;}.bg-black {background-color: rgba(0, 0, 0, 0.95) !important;}.stl-cares-close {display: inline-block;vertical-align: text-bottom;fill: currentColor;}#caresNotice {font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"; font-size:16px !important; line-height:1.5 !important; position: relative;top: 0;left: 0;right: 0;padding: 16px !important;z-index: 999999;}#closeButton {display: inline-block;padding: 0;font-size: inherit;color: #0366d6;text-decoration: none;white-space: nowrap;cursor: pointer;-webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;background-color: transparent;border: 0;-webkit-appearance: none;-moz-appearance: none;appearance: none;padding: 8px !important;margin-left: 4px !important;}.sr-only {position: absolute;width: 1px;height: 1px;padding: 0;overflow: hidden;clip: rect(0, 0, 0, 0);word-wrap: normal;border: 0;}#stl-cares-learn-more {position: relative;display: inline-block;padding: 6px 12px;font-size: 14px;font-weight: 600;line-height: 20px;white-space: nowrap;vertical-align: middle;cursor: pointer;-webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;background-repeat: repeat-x;background-position: -1px -1px;background-size: 110% 110%;border: 1px solid rgba(27, 31, 35, 0.2);border-radius: 0.25em;-webkit-appearance: none;-moz-appearance: none;appearance: none;color: #24292e;background-color: #eff3f6;background-image: linear-gradient(-180deg, #fafbfc 0%, #eff3f6 90%);text-decoration: none;}#stl-cares-learn-more:hover {background-color: #e6ebf1;background-image: linear-gradient(-180deg, #f0f3f6 0%, #e6ebf1 90%);background-position: 0 -0.5em;border-color: rgba(27, 31, 35, 0.35);}#stl-contact-us-link {color: white;}</style> <div id="caresNotice" class="py-2 px-3 f5 text-white bg-black rounded-0"> <div class="d-flex flex-justify-between flex-items-center mx-auto" style="max-width: 980px;"><div><strong></strong> <span class="d-none d-sm-inline-block">' + caresMessage + '</span> </div> <button id="closeButton" type="button" class="btn-link text-white p-2 ml-1"> <svg aria-hidden="true" class="stl-cares-close" focusable="false" height="16" version="1.1" viewBox="0 0 12 16" width="12"><path fill-rule="evenodd" d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48z"></path></svg> <span class="sr-only">Dismiss</span> </button> </div> </div>';
                    
                    if(document.getElementById('caresNotice') === null) document.body.insertAdjacentHTML('afterbegin', caresNoticeHTML)

                    var trkCaresCloseLink = function (e) {
                        if(a11yClick(e)) {
                            e.stopPropagation();
                            document.getElementById('caresNotice').style.display = 'none';
                            window.sessionStorage.setItem(orgId + 'caresNotice', !0)
                            // user clicked close
                            if (isAdobeLaunch) {
                                _satellite.track("site_tool.interaction",{"toolName": window.location.hostname + ": CARES Banner Close"});
                            } 
                        }
                    };
                    var trkCaresArticleLink = function (e) {
                        if(a11yClick(e)) {
                            e.stopPropagation();
                            document.getElementById('caresNotice').style.display = 'none';
                            // clicking article link will not close the banner for the session this time
                            // window.sessionStorage.setItem(orgId + 'caresNotice', !0)
                            // user clicked article link
                            if (isAdobeLaunch) {
                                _satellite.track("site_tool.interaction",{"toolName": window.location.hostname + ": " + e.target.dataset.sitetool });
                            } 
                        }
                    };

                    document.getElementById('closeButton').addEventListener('click',trkCaresCloseLink,false);
                    document.getElementById('closeButton').addEventListener('keydown',trkCaresCloseLink,false);
                    if (document.querySelector('#caresNotice .cares-article-link')) {
                        document.querySelector('#caresNotice .cares-article-link').addEventListener('click',trkCaresArticleLink,false);     
                        document.querySelector('#caresNotice .cares-article-link').addEventListener('keydown',trkCaresArticleLink,false); 
                    }
                    if (document.querySelector('#caresNotice .contactEMAddr')) { 
                        document.querySelector('#caresNotice .contactEMAddr').addEventListener('click', function (e) {
                            e.stopPropagation()
                            var thisEMAddr = document.querySelector('#caresNotice .contactEMAddr')
                            let uname = thisEMAddr.dataset.uname.trim()
                            let domain = thisEMAddr.dataset.domain.trim()
                            let email = `mailto:${uname}@${domain}`
                            window.location.href = email
                        })
                    }
                }
            }
        }
        caresRequest.send(null);
    }

    // CARES Act banner function commented out 1/3/2022
    // if(!window.sessionStorage.getItem(orgId + 'caresNotice') && useRewrites == "True" && (typeof customCARES === "undefined" || customCARES == false)) displayCARES();

    // CARES video tracking 
    // -----------------------------------------------------------------
    function caresVideoLaunchTracker(e) {
        var video = document.getElementById("cares-video");
        var mediaName = "CARES Act Video";
        var mediaLength = video.duration;
        var mediaPlayerName = "HTML5 Basic Player";
        var mediaOffset;
        var videoAction = "";
    
        // Define video offset
        if (video.currentTime > 0) {
            mediaOffset = Math.floor(video.currentTime);
        } else {
            mediaOffset = 0;
        }
    
        if (e.type == "play") {
            videoAction = "view";
            _satellite.track("video",{
                "videoAction":videoAction,
                "videoPlayer":mediaPlayerName, 
                "videoTitle":mediaName,
                "videoDuration":mediaLength,  // pass as integer
                "mediaOffset":mediaOffset  // pass as integer
            });
        }
        else if (e.type == "pause") {
            videoAction = "pause";
            _satellite.track("video",{
                "videoAction":videoAction,
                "videoPlayer":mediaPlayerName, 
                "videoTitle":mediaName,
                "videoDuration":mediaLength,  // pass as integer
                "mediaOffset":mediaOffset  // pass as integer
            });
        }
        else if (e.type == "ended") {
            videoAction = "complete";
            video.load();
            _satellite.track("video",{
                "videoAction":videoAction,
                "videoPlayer":mediaPlayerName, 
                "videoTitle":mediaName,
                "videoDuration":mediaLength,  // pass as integer
                "mediaOffset":mediaOffset  // pass as integer
            });
        }
        else if (e.type == "ontimeupdate") {
        //video.ontimeupdate = (event) => {
            var currentTime = video.currentTime;
            // 25%
            if (currentTime >= (mediaLength * 0.25) && !window.complete_25) {
                console.log("VIDEO 25% COMPLETE");
                _satellite.track("video",{
                    "videoAction":"25",
                    "videoPlayer":mediaPlayerName, 
                    "videoTitle":mediaName,
                    "videoDuration":mediaLength,  // pass as integer
                    "mediaOffset":mediaOffset  // pass as integer
                });
                window.complete_25 = true;
            }
            // 50%
            else if (currentTime >= (mediaLength * 0.5) && !window.complete_50) {
                console.log("VIDEO 50% COMPLETE");
                _satellite.track("video",{
                    "videoAction":"50",
                    "videoPlayer":mediaPlayerName, 
                    "videoTitle":mediaName,
                    "videoDuration":mediaLength,  // pass as integer
                    "mediaOffset":mediaOffset  // pass as integer
                });
                window.complete_50 = true;
            }
            // 75%
            else if (currentTime >= (mediaLength * 0.75) && !window.complete_75) {
                console.log("VIDEO 75% COMPLETE");
                _satellite.track("video",{
                    "videoAction":"75",
                    "videoPlayer":mediaPlayerName, 
                    "videoTitle":mediaName,
                    "videoDuration":mediaLength,  // pass as integer
                    "mediaOffset":mediaOffset  // pass as integer
                });
                window.complete_75 = true;
            }
            return false;
        };
        //seeking? 
        //seeked?
    };
    function caresVideoTracker(e) {
        var video = document.getElementById("cares-video");
        var mediaName = "CARES Act Video";
        var mediaLength = video.duration;
        var mediaPlayerName = "HTML5 Basic Player";
        var mediaOffset;

        // Define video offset
        if (video.currentTime > 0) {
            mediaOffset = Math.floor(video.currentTime);
        } else {
            mediaOffset = 0;
        }

        // Call video start after all metadata has loaded. This will allow
        // tracking to know the length of the video and properly detect
        // when the video is completed during the "ended" event
        if (e.type == "play") {
            console.log("Play activated");
        }

        // Call on scrub start
        if (e.type == "seeking") {
            //
        }

        // Call on scrub stop
        if (e.type == "seeked") {
            //
        }

        // Call on pause
        if (e.type == "pause") {
            //
        }

        // Call on video complete
        if (e.type == "ended") {
            console.log("Ended");
            video.load();
        }
    };

    if(document.getElementById('cares-video') !== null){
        var caresVideo = document.getElementById("cares-video");
        // % complete tracking
        window.complete_25 = false;
        window.complete_50 = false;
        window.complete_75 = false;
        if(isAdobeLaunch){ 
            // Launch video tracking
            caresVideo.addEventListener("play", caresVideoLaunchTracker, false);
            caresVideo.addEventListener("ended", caresVideoLaunchTracker, false);
            caresVideo.addEventListener("timeupdate", caresVideoLaunchTracker, false);
        }
    }

    var displayGlobalPopup = function () {
        // use jQuery(window).on("load", function(){ if magnific popup
        var currDate = new Date();
        var cgaNoticeStartDate = window.cgaTestDate || new Date('1/1/2024 00:01');
        var cgaNoticeEndDate1 = new Date('3/31/2024 23:58');
        var cgaNoticeEndDate2 = new Date('3/31/2024 23:59');
        var inDateRange = false;
        var showBannerPage = false;
        if ((document.body.id == 'home-page' || 
            document.body.classList.contains("home-page") || 
            document.body.classList.contains("HomePage") ||
            document.querySelector('.stl-journey-paths') !== null || 
            document.querySelector('.stl_clientMissionBody') !== null ||  
            document.body.classList.contains('article-page') || 
            document.body.classList.contains('Article') ||
            document.body.classList.contains('interior-page') ||
            document.body.classList.contains('InteriorPage') ||
            document.body.classList.contains('contact-page') ||
            document.body.classList.contains('contact-us') ||
            document.body.classList.contains('ContactUsPage') ||
            typeof document.forms.brochureform !== "undefined") &&
            !document.body.classList.contains('landing-page')) {
                showBannerPage = true;
        }

        if (currDate >= cgaNoticeStartDate && currDate < cgaNoticeEndDate2) {
            inDateRange = true; // date between 12/19 and 3/31
        }

        if(inDateRange && showBannerPage){
            // check if we're on home page or cga page
            // var homePath0 = window.location.hostname.split('.')[0];
            // var homePath1 = typeof window.location.hostname.split('.')[2] !== "undefined" ? '-' + window.location.hostname.split('.')[1] : '';
            // var homePath = homePath0 + homePath1 + '-page';
            // if (document.body.id == 'home-page' || 
            //     document.body.classList.contains("home-page") || 
            //     document.body.classList.contains("HomePage") ||
            //     document.body.id == homePath || 
            //     document.querySelector('.stl-journey-paths') !== null || 
            //     document.querySelector('.stl_clientMissionBody') !== null || 
            //     document.body.id == 'charitable-gift-annuities-page' || 
            //     document.body.classList.contains('charitable-gift-annuities') || 
            //     (typeof document.forms.brochureform !== "undefined" && document.forms.brochureform.pageName.value == 'Charitable Gift Annuities')
            // ) {
                // Check if site excludes CGA. Combined banner won't use this check
                document.body.insertAdjacentHTML('beforeend','<div id="cga-check" class="ge-cga ge-dcga" aria-hidden="true" style="display:inline"></div>');
                var excludeCGA = getComputedStyle(document.getElementById('cga-check')).getPropertyValue('display') === "none";
                if (excludeCGA) {
                    // site excludes CGA, do not show popup
                    sessionStorage.setItem(orgId+'cgaRateGlobalPopup','true');
                } else {
                    var htmlClass = document.documentElement.classList;
                    //var dash = htmlClass.contains('emdash') ? '&mdash;' : htmlClass.contains('emdash-spaces') ? ' &mdash; ' : htmlClass.contains('endash') ? '&ndash;' : htmlClass.contains('endash-spaces') ? ' &ndash; ' : '&mdash;';
                    var btnText = htmlClass.contains('sentence-case') ? 'Get the details' : 'Get the details';
                    var cgaPopCopy = '';
                    //var secure2Copy = '<p><strong id="stl-announcement__title">NEW LAWS: </strong><span id="stl-announcement__description">Recent changes to retirement laws may affect you! <a href="/new-retirement-laws" id="stl-announcement__article-link" class="stl-announcement-link">Find out</a> what they could mean for your saving and your giving.</span></p>';
                    if(currDate >= cgaNoticeStartDate && currDate < cgaNoticeEndDate1) {
                        // date between 12/19 and 12/31, show version 1 content
                        var title1 = htmlClass.contains('sentence-case') ? 'Big news you should know!' : 'Big news you should know!';
                        cgaPopCopy = '<p class="ge-cga ge-dcga"><strong id="stl-announcement__title">'+ title1 +'</strong> <span id="stl-announcement__description">Charitable gift annuity rates have gone up yet again, making the payouts you’d receive the highest in 16 years. <a href="/2024-cga-rate-increase" id="stl-announcement__article-link" class="stl-announcement-link">' + btnText + '</a> so you can lock in these great rates and get fixed, reliable income for life.</span></p>';
                    }
                    if(currDate >= cgaNoticeEndDate1 && currDate < cgaNoticeEndDate2) {
                        // date between 1/1 and 3/31, show version 2 content
                        var title2 = htmlClass.contains('sentence-case') ? 'Big news you should know!' : 'Big news you should know!';
                        cgaPopCopy = '<p class="ge-cga ge-dcga"><strong id="stl-announcement__title">'+ title2 +'</strong> <span id="stl-announcement__description">Charitable gift annuity rates have gone up yet again, making the payouts you’d receive the highest in 16 years. <a href="/2024-cga-rate-increase" id="stl-announcement__article-link" class="stl-announcement-link">' + btnText + '</a> so you can lock in these great rates and get fixed, reliable income for life.</span></p>';
                    }

                    var cgaNoticeHTML = '<style>.stl-announcement-banner {font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"; font-size:16px !important; line-height:1.5 !important; padding: 20px; background-color: rgba(0, 0, 0, 0.95) !important; z-index: 999999;} .stl-announcement-banner.top-banner {position: relative; top: 0; left: 0; right: 0; } .stl-announcement-banner .stl-announcement-container {display: flex; justify-content: space-between; align-items: flex-start; max-width: 1040px; margin: 0 auto;} .stl-announcement-banner p {color: #fff !important; margin: 0 !important;} .stl-announcement-banner p + p {margin-top:0.75em !important;} .stl-announcement-banner .stl-announcement-link {color:#fff !important; text-decoration:underline !important;} .stl-announcement-banner .stl-announcement-link:hover, .stl-announcement-banner .stl-announcement-link:focus {text-decoration:none !important;} .stl-announcement-close {display: inline-block; font-size: inherit; color: inherit; text-decoration: none;white-space: nowrap;cursor: pointer;-webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;background-color: transparent;border: 0;appearance: none;padding: 8px !important; margin: -6px 0 0 30px !important;} .stl-announcement-banner .stl-close-svg {display: inline-block; vertical-align: text-bottom; fill: #fff; width: 15px; height: 20px;} .sr-only {position: absolute;width: 1px;height: 1px;padding: 0;overflow: hidden;clip: rect(0, 0, 0, 0);word-wrap: normal;border: 0;}</style> <div id="stl-announcement__top-banner" class="stl-announcement-banner top-banner ge-cga ge-dcga" role="dialog" aria-labelledby="stl-announcement__title" aria-describedby="stl-announcement__description"> <div class="stl-announcement-container"> <div class="stl-announcement-content">' + cgaPopCopy + '</div> <button id="stl-announcement__close-btn" type="button" class="stl-announcement-close"><svg aria-hidden="true" class="stl-close-svg" focusable="false" tabindex="-1" height="16" version="1.1" viewBox="0 0 12 16" width="12"><path focusable="false" tabindex="-1" fill-rule="evenodd" d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48z"></path></svg><span class="sr-only">Dismiss</span></button></div> </div>';

                    document.body.insertAdjacentHTML('afterbegin',cgaNoticeHTML);

                    // set banner height data attribute
                    var bannerHeight = document.getElementById('stl-announcement__top-banner').offsetHeight;
                    if(typeof getBannerHeight !== 'undefined' && document.getElementById('stl-cms') !== null) document.getElementById('stl-cms').style.paddingTop = bannerHeight + 'px';
                    var bannerResizeTimer;
                    window.onresize = () => {
                        clearTimeout(bannerResizeTimer);
                        bannerResizeTimer = setTimeout(() => {
                            var newBannerHeight = document.getElementById('stl-announcement__top-banner').offsetHeight;
                            if(typeof getBannerHeight !== 'undefined' && document.getElementById('stl-cms') !== null) document.getElementById('stl-cms').style.paddingTop = newBannerHeight + 'px';   
                        }, 250);
                    };

                    var trkCloseLink = function (e) {
                        if(a11yClick(e)) {
                            e.stopPropagation();
                            document.getElementById('stl-announcement__top-banner').remove();
                            sessionStorage.setItem(orgId+'cgaGlobalPopup','true');
                            if (isAdobeLaunch) {
                                _satellite.track('site_tool.interaction',{'toolName': 'CGA Rate January 2024 - Close Button' });
                            } 
                        }
                    };
                    var trkArticleLink = function (e) {
                        if(a11yClick(e)) {
                            e.stopPropagation();
                            // clicking article link will not close the banner for the session this time
                            // sessionStorage.setItem(orgId+'cgaRateGlobalPopup','true');
                            if (isAdobeLaunch) {
                                _satellite.track('site_tool.interaction',{'toolName': 'CGA Rate January 2024 - Banner Article Link' });
                            } 
                        }
                    };

                    document.getElementById('stl-announcement__close-btn').addEventListener('click',trkCloseLink,false);
                    document.getElementById('stl-announcement__close-btn').addEventListener('keydown',trkCloseLink,false);
                    document.getElementById('stl-announcement__article-link').addEventListener('click',trkArticleLink,false);     
                    document.getElementById('stl-announcement__article-link').addEventListener('keydown',trkArticleLink,false); 
                    // view code prior to 5/31/2022 for magnific implementation
                }
            //} 
        } else {
            if(sessionStorage.getItem(orgId+'cgaGlobalPopup') !== null) sessionStorage.removeItem(orgId+'cgaGlobalPopup');
        }
    }
    if(!sessionStorage.getItem(orgId+'cgaGlobalPopup') && useRewrites === "True" && typeof customCGAPopup === "undefined") {
        displayGlobalPopup();
    }

    var cgaFundItQCD = function () {
        var navLinks = Array.from(document.querySelectorAll('.stl-nav a'));
        // On CGA page, add IRA Assets link to Fund It section
        if (document.body.id == 'charitable-gift-annuities-page' || 
        document.body.classList.contains('charitable-gift-annuities') || 
        (typeof document.forms.brochureform !== "undefined" && document.forms.brochureform.pageName.value == 'Charitable Gift Annuities')) {
            // On the CGA page
            if (document.querySelector('.learn-how-to-fund') !== null && navLinks.length > 0 && document.querySelector('.learn-how-to-fund a[href*="ira"]') === null && document.querySelector('.learn-how-to-fund a[href*="qcd"]') === null && document.querySelector('.learn-how-to-fund a[href*="qualified-charitable-distribution"]') === null) {
                // No IRA link exists in the Fund It section, check top navigation for IRA URL
                var iraLink = '';
                if (typeof navLinks.find(el => el.textContent.includes('IRA')) !== 'undefined') {
                    iraLink = navLinks.find(el => el.textContent.includes('IRA')).href;
                } else if (typeof navLinks.find(el => el.textContent.includes('QCD')) !== 'undefined') {
                    iraLink = navLinks.find(el => el.textContent.includes('QCD')).href;
                } else if (typeof navLinks.find(el => el.textContent.includes('Qualified Charitable Distribution')) !== 'undefined') {
                    iraLink = navLinks.find(el => el.textContent.toLowerCase().includes('qualified charitable distribution')).href;
                } else {
                    // No IRA/QCD link in the navigation, so an IRA link cannot be added
                }
                
                if (iraLink !== '') {
                    var assetsCasing = document.documentElement.classList.contains('sentence-case') ? 'assets' : 'Assets'
                    var iraLinkHtml = `<li><a href="${iraLink}"><span class="force-upper">IRA</span>&nbsp;${assetsCasing}</a></li>`
                    document.querySelector('.learn-how-to-fund ul').insertAdjacentHTML('beforeend', iraLinkHtml)
                    if (document.querySelector('#cga-ira-link') !== null && document.querySelector('#cga-ira-link a') === null) {
                        var mainCopyIRALinkContent = document.querySelector('#cga-ira-link').textContent;
                        var mainCopyIRALinkHtml = `<a href="${iraLink}">${mainCopyIRALinkContent}</a>`;
                        document.querySelector('#cga-ira-link').textContent = '';
                        document.querySelector('#cga-ira-link').insertAdjacentHTML('beforeend',mainCopyIRALinkHtml);
                    }
                }
            }
        }
        // Add CGA link on RPA page
        if (document.querySelector('#rpa-cga-link') !== null && document.querySelector('#rpa-cga-link a') === null && navLinks.length > 0) {
            // span does not contain link, check the navigation for the CGA link
            var cgaLink = '';
            if (typeof navLinks.find(el => el.textContent.toLowerCase().includes('gift annuit')) !== 'undefined') {
                cgaLink = navLinks.find(el => el.textContent.toLowerCase().includes('gift annuit')).href;
                var rpaCGALinkContent = document.querySelector('#rpa-cga-link').textContent;
                var rpaCGALinkHtml = `<a href="${cgaLink}">${rpaCGALinkContent}</a>`;
                document.querySelector('#rpa-cga-link').textContent = '';
                document.querySelector('#rpa-cga-link').insertAdjacentHTML('beforeend',rpaCGALinkHtml);
            } else {
                // No CGA link in the navigation, so a CGA link cannot be added
            }
        } 
    }

    cgaFundItQCD();

    /* Contact Us page form validation */
    jQuery('#stl-contact-form').submit(function (e) {
        let fName = jQuery.trim(document.forms['contactform']['fname'].value)
        let lName = jQuery.trim(document.forms['contactform']['lname'].value)
        let email = jQuery.trim(document.forms['contactform']['email'].value)

        let checkpoint = function () {
            if (document.forms['contactform']['honeypot']) return jQuery.trim(document.forms['contactform']['honeypot'].value)
            if (document.forms['contactform']['contactCheckpoint']) return jQuery.trim(document.forms['contactform']['contactCheckpoint'].value)
        }

        if ('' != checkpoint()) {
            //spam bot filled in hidden field, bypass form submission
            e.stopImmediatePropagation()
            return false
        } else if (fName != '' && lName != '' && email != '') {
            if (!isEmail(email)) {
                alert('Please enter a valid email address')
                e.stopImmediatePropagation()
                return false
            } else {
                return true
            }
        } else {
            alert('Please fill your first name, last name and email address')
            e.stopImmediatePropagation()
            return false
        }
    })
    
    Stelter.standardFormsValidation = function() {
        jQuery('.stl-input-field input[required="required"]').blur(function() {
            var isFormValid = true;

            // Store the parent input group wrapper
            var parent = jQuery(this).parent();
            var parentForm = jQuery(this).closest(jQuery('form'));

            if (!jQuery(this).val()) {
                //input is empty
                parent.removeClass('active');
                parent.removeClass('valid').addClass('invalid');
            }
            else if (jQuery(this).attr('type') == "email" && (jQuery(this).val().indexOf("@") == -1)) {
                // invalid email address
                parent.removeClass('active');
                parent.removeClass('valid').addClass('invalid');
                return false;
            }
            else {
                // input is valid
                parent.removeClass('invalid').addClass('valid');
            }
            // check other required inputs. If all valid, enable submit button            
            parentForm.find(jQuery('input:not(.hidden)[required="required"]')).each(function() {
                if (!jQuery(this).parent().hasClass('valid')) {
                    isFormValid = false;
                }
            })
            if (isFormValid == true) {
                parentForm.find(jQuery('button[type="submit"]')).removeAttr('disabled');
            }
            else {
                parentForm.find(jQuery('button[type="submit"]')).attr('disabled','disabled');
            }
        })
    }
    Stelter.standardFormsValidation();
    
    Stelter.standardFormsSubmit = function() {
        var tierArray = siteControlTier.split(",").map(tier => tier.trim());
        var sdsArray = ["Standard","Plus","SDS Guides"];
        var sdsSite = sdsArray.some(tier => tierArray.includes(tier));
        // Link PEPC Lesson and Record book pdf downloads to one visible checkbox element
        if (jQuery('#planning-toolkit-page').length > 0) {
            var visibleCheckbox = jQuery("#pepc");
            var hiddenCheckbox = jQuery("#recordbook");

            visibleCheckbox.on('change', function(){
                hiddenCheckbox.prop('checked',this.checked);
            });
        }
        
        // Global variable to indicate whether reCaptcha is included on the form (false by default)
        var reCaptchaIncluded = false;

        // Generate recaptcha given an id of an empty div
        function generateCaptcha(formcaptcha) {
            if (typeof recaptchaKey === "undefined" || recaptchaKey == "" || typeof isIE11 !== "undefined") {
                return false;
            } else {
                window.addEventListener("load", function (event) {
                    grecaptcha.render(formcaptcha, {
                        'sitekey': recaptchaKey
                    });
                });
                // set reCaptchaincluded to true
                reCaptchaIncluded = true;
            }
        }

        // Render recaptcha if there are any standard forms and this site has recaptcha enabled
        if(document.getElementById('standard-form-captcha')) {
            generateCaptcha("standard-form-captcha");
        }
        if(document.querySelector('.standard-form-captcha')) {
            document.querySelectorAll('.standard-form-captcha').forEach(function(el) {
                generateCaptcha(el.id);
            })
        }
        
        // Save timestamp
        var loadTime = jQuery.now();
        
        // If any options are global and we are not in "true live" (which utilizes url rewrites), add the site control parameter to the global option's href
        try {
            if (useRewrites == "False") {
                jQuery('.global-option').each(function() {
                    var globalOption = jQuery(this); //store for reference
                    var href = globalOption.attr('href'); //store for reference

                    // If we are in preview, need to include "dsspreview" in the href
                    if (serverIs == "preview") {
                        globalOption.attr('href', "//" + window.location.hostname + "/dsspreview" + href + "?sitecontrol=" + pageId);
                    }
                    else {
                        globalOption.attr('href', "//" + window.location.hostname + href + "?sitecontrol=" + pageId);
                    }
                })
            }
        }
        catch (err) {
            console.log("useRewrites is not passed as a global variable in this environment | " + err);
        }

        // Submit standard form
        jQuery('form.stl-custom-form').submit(function(e) {
            //cache this form
            var form = jQuery(this);
            
            // Check checkpoint
            if (form.find(jQuery('.checkpoint')).length > 0 && typeof form.find(jQuery('.checkpoint')).attr('value') !== "undefined" && form.find(jQuery('.checkpoint')).attr('value') !== "") {
                return false;
            }
            
            // Check timestamp
            var submitTime = jQuery.now();
            var timeToSubmit = submitTime - loadTime;
            if (timeToSubmit < 3000) {
                return false;
            }

            e.preventDefault();
            
            // Show submitted confirmation
            form.find('.submit-text').addClass('visible');
            form.find('button').attr('disabled','disabled');

            var nextpage = form.find(jQuery("input[name='nextpage']"));
            var nextpageVal = nextpage.attr('value');
            var blankTarget = form.attr('target') === '_blank' && nextpage.attr('data-samepage') !== 'true';
            if (blankTarget) {
                loading('customFormWindow');
            }

            // Check for download options 
            if (form.find(jQuery('.download-option')).length > 0) {
                var files = form.find(jQuery('.download-option:checked')).map(function() {
                    //return this.value; //create array of filenames
                    return jQuery(this).attr('data-value');
                }).get();
                
                var tabs = form.find(jQuery('.tab-option:checked')).map(function() {
                    //return this.value; //create array of filenames
                    return jQuery(this).attr('data-value');
                }).get();

                console.log("tabs: " + tabs);
                console.log("files: " + files);

                // If more than one download option selected, create a link and set the download attribute
                if (files.length > 1) {
                    // Create link to download files
                    var dlink = document.createElement('a');
                    dlink.style.display = 'none';
                    document.body.appendChild(dlink);

                    // Download each file in the files array
                    for (var i=0, num=files.length; i < num; i++){
                        dlink.setAttribute('download', '');
                        dlink.setAttribute('href', files[i]);
                        dlink.click();
                    }
                    document.body.removeChild(dlink);
                }

                // If only one download selected, open in a new tab
                else if (files.length == 1) {
                    // Create link to open file
                    var dlink = document.createElement('a');
                    dlink.style.display = 'none';
                    document.body.appendChild(dlink);

                    dlink.setAttribute('href', files[0]);
                    dlink.setAttribute('target', '_blank');
                    dlink.click();
                    document.body.removeChild(dlink);
                }
                
                // If any tab options are selected, open them in new tabs
                if (tabs.length > 0) {
                    // Create link to open file
                    var dlink = document.createElement('a');
                    dlink.style.display = 'none';
                    document.body.appendChild(dlink);
                    
                    // Open each tab in the tabs array
                    for (var i=0, num=tabs.length; i < num; i++){
                        dlink.setAttribute('href', tabs[i]);
                        dlink.setAttribute('target', '_blank');
                        dlink.click();
                    }
                    document.body.removeChild(dlink);
                }
                
                // If none of the available options selected, prompt the user to select
                if (files.length <= 0 && tabs.length <= 0) {
                    alert("Please select a resource to download by checking one or more boxes");
                    form.find('.submit-text').removeClass('visible');
                    return false;
                }
                
                
            }
            
            // Check if this form contains items to unlock
            if (form.find(jQuery('.unlock-option')).length > 0) {
                
                var unlockOptions = form.find(jQuery('.unlock-option:checked')).map(function() {    
                    //return the class name of items to unlock
                    return jQuery(this).attr('data-unlock');
                }).get();
                
                // If any "unlock" options are selected, mark their corresponding download item as visible 
                if (unlockOptions.length > 0) {
                    // mark as visible the options that are selected 
                    for (var i=0, num=unlockOptions.length; i < num; i++) {
                        form.find(jQuery('.view-options .' + unlockOptions[i] + '')).removeClass('hide');
                        form.find(jQuery('.related-options .' + unlockOptions[i] + '')).addClass('hide');
                    }
                    
                    // if all of the options are selected to view, hide the related options section
                    if (unlockOptions.length == jQuery('.unlock-option').length) {
                        form.find('.related-options').addClass('hide');
                    }
                }
            }

            // Send Form to IGX and route to nextpage input
            var data = jQuery(this).serialize();
            console.log("recaptchaIncluded: " + reCaptchaIncluded);
            var url = "";

            if (reCaptchaIncluded) {
                if (typeof recaptchaKey === "undefined" || recaptchaKey === "" || form.hasClass('recaptcha-disabled')) {
                    url = "../../../action/processform.cshtml";
                } else if (form.hasClass('ebro-process')) {
                    url = "../../../action/ebrosendemailwithcaptcha.cshtml";
                } else {
                    url = "../../../action/processformwithcaptcha.cshtml";
                }
            } else {
                url = "../../../action/processform.cshtml";
            }

            jQuery.ajax({
                url: url,
                data: data,
                //dataType: 'json',
                type: 'POST',
                success: function (response) {
                    if (typeof response === "string") {
                        if (response.trim().indexOf("<script>") > -1){
                            var respString = response.replace(/\r?\n|\r\s+/g, '');
                            var respScriptNextPage = respString.split('"')[1];
                            response = {"result":"script","content":respScriptNextPage};
                            nextpageVal = response.content;
                        } else {
                            response = JSON.parse(response)
                        }
                    }
                    
                    console.log("response: " + JSON.stringify(response));

                    if (response.result === "failed") {
                        alert(response.content);
                        e.preventDefault();
                        // Remove submitted confirmation
                        form.find('.submit-text').removeClass('visible');
                        form.find('button').removeAttr('disabled');
                        return false;
                    }
                    else {

                        //e.preventDefault();

                        // Nextpage
                        // If attribute data-samepage="true" is set on the nextpage input, then we should not route to the value of nextpage; instead, activate the form submission text on the current page
                        if (form.find(jQuery("input[name='nextpage']")).attr('data-samepage') == "true") {
                            if (jQuery(window).width() >= 768) {
                                //set the height of the form to not collapse
                                if (form.css('height') < (form.find(jQuery('.visible-after-submit')).length)) {
                                    form.css('height',form.css('height'));
                                }
                            }
                            form.addClass('loading');
                            if (jQuery(window).width() < 768) {
                                //scroll to top of form on mobile
                                jQuery('html, body').animate({
                                    scrollTop: (form.offset().top - 50)
                                }, 100);
                            }
                            setTimeout(function() {
                                form.removeClass('loading');
                                form.addClass('after-submit');
                            }, 800);
                            return true;
                        }
                        else {
                            if (useRewrites == "False" && sdsSite && nextpageVal.indexOf('guide') > -1 && nextpageVal.indexOf('//') == -1) {
                                nextpageVal = nextpageVal + "?sitecontrol=" + pageId; 
                            }
                            if (useRewrites == "True" && nextpageVal.indexOf(".xml?ebr=x69") > -1){
                                nextpageVal = "/ebrochure-page?ebr=x69";
                                console.log('nextpage path rendered')
                            }
                            if (blankTarget) {
                                customFormWindow.location = nextpageVal;
                                if (jQuery.magnificPopup.instance.isOpen) {
                                    jQuery.magnificPopup.close()
                                }
                            } else {
                                window.open(nextpageVal, '_self'); //go to the next page after submit
                            } 

                        }
                    }

                },
                error: function (response) {
                    //failed to send email 
                    console.log(response);
                }
            });
        })
    }
    Stelter.standardFormsSubmit();
    
    Stelter.globalAnnouncement = function() {
        if (jQuery('#stl-announcement').length > 0) {
            // Open announcement if the user has not interacted with it
            if (!localStorage.getItem('stl_global_announcement')) {
                setTimeout(function() {
                    jQuery.magnificPopup.open({
                        items: {
                            src: '#stl-announcement'
                        },
                        mainClass: 'stl-announcement',
                        type:'inline',
                        callbacks: {
                            close: function() {
                                //localStorage.setItem('stl_global_announcement', 'true'); //removed
                            }
                        }
                    });
                },2000);
            }
            // If user goes to announcement nextpage, set local storage so they will not see announcment again (removed this functionality)
//            jQuery('#announcement-nextpage').click(function() {
//                localStorage.setItem('stl_global_announcement', 'true');
//            })
            // If user selects "don't show me this again" button, set local storage so they will not see announcement again
            jQuery('#announcement-nextpage').next().click(function() {
                localStorage.setItem('stl_global_announcement', 'true');
                var magnificPopup = $.magnificPopup.instance;
                magnificPopup.close();
            })
        }    
    }
    //Stelter.globalAnnouncement();
	
	Stelter.digitalGuideLinks = function() {
		// Update digital guide links to ensure they work in staging
		jQuery('.digital-guide-link').each(function () {
			// if we're in staging or preview
			if (useRewrites == "False") {
				var link = $(this).attr('href');
				// if link does not include site control query param already, add it
				if (link.indexOf('sitecontrol') < 0) {
					var siteControlParam = "sitecontrol=" + pageId;
					// if link already has query params, add site control to the end
					if (link.indexOf('?') >= 0) {
						link = link + "&" + siteControlParam;
					}
					// otherwise, add it as the first param
					else {
						link = link + "?" + siteControlParam;
					}
					// set the new href
					$(this).attr('href', link);
				}
			}
		})
	}
	Stelter.digitalGuideLinks();
	
    //Global CTAs
    Stelter.globalCTALinks = function() {

        if (document.querySelector(".syndicated") && document.querySelector(".stl-globalCTA")){

            let isSDS = false, hasGuides = false, tierArray = siteControlTier.split(',').map(function(tier) {
                return tier.trim()
            }), guideTiers = ['Standard', 'Plus', 'SDS Guides'], sdsTiers = ['Standard', 'Plus'];
    
            const containsTier = (array, values) => values.some(value => array.includes(value));
            hasGuides = containsTier(tierArray, guideTiers);
            isSDS = containsTier(tierArray, sdsTiers);

            let CTAs = document.querySelectorAll(".stl-globalCTA");
            [].forEach.call(CTAs, function(cta) {
                //Guide CTAs
                let ghref, guideLinks = cta.querySelectorAll(".global-guide a");
                [].forEach.call(guideLinks, function(glink) {
                    if(hasGuides){
                        ghref = glink.dataset.link_sds;
                        // if we're in staging or preview
                        if ('False' == useRewrites) {
                            // if link does not include site control query param already, add it
                            if (ghref.indexOf('sitecontrol') < 0) {
                                let siteControlParam = 'sitecontrol=' + homeId; 
                                ghref = 0 <= ghref.indexOf('?') ? ghref + '&' + siteControlParam : ghref + '?' + siteControlParam;
                            }
                        }
                    }else {
                        // remove cta if no dmp link
                        if(glink.dataset.link_dmp){
                            ghref = glink.dataset.link_dmp;
                        }else {
                            cta.remove();
                        }
                    }
                    glink.href = ghref;
                    glink.target = "_blank";
                });

                // Replace // with / in Live links
                let ctahref, ctaLinks = cta.querySelectorAll(".stl-globalCTA a");
                [].forEach.call(ctaLinks, function(ctalink) {
                    ctahref = ctalink.getAttribute('href');
                    if (useRewrites) {
                        ctalink.href = ctahref.replace(/^\/\//, '/');
                    }
                });

            });
        }
    }
    Stelter.globalCTALinks();


    //set the orgId to GI URLs without orgId
    [].slice.call(document.querySelectorAll('.lightbox, .home-lightbox, .secondary-lightbox')).forEach(function(el){
        let isGI = el.href.indexOf('giftillustrator.com') > -1
        let calcUrl = el.href
        if (isGI) {
            calcUrl = calcUrl.replace('http:','https:').replace(':8080','')
            if (calcUrl.indexOf('web.') > -1 && calcUrl.indexOf('orgId') === -1 ) {
                calcUrl = calcUrl + '?orgId=' + orgId
            }
            if (calcUrl.indexOf('calculator.') > -1 && calcUrl.indexOf('@[OrgId') > -1 ) {
                calcUrl = calcUrl.replace('@[OrgId]',orgId)
            }
            el.href = calcUrl
        }
    })

    // close Gift Illustrator 2.0 popup with escape
    window.addEventListener("message",(event) => {
        if (!event.origin.includes('giftillustrator.com') && !event.origin.includes('api.stelter.com')) return;
        if(event.data === 'Close Gift Illustrator' && document.querySelector('.mfp-close') !== null) {
            document.querySelector('.mfp-close').click()
        }
    }, false);

    //set the getting started page body background none
    jQuery('.not-sure-where-to-being-questionnaire').parent().css('background-image', 'none')
    jQuery('.fancybox-form').magnificPopup({
        type: 'inline',
        midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    })

    jQuery('.stl-journey-paths a.stl-popup').attr('oncontextmenu', 'return false;')

    let alphabet = ('abcdefghijklmnopqrstuvwxyz').split('')
    jQuery('.not-sure-where-to-being-questionnaire input').on('click', function () {
        let parent = jQuery(this).parents('li')
        let choice = parent.attr('id') + alphabet[jQuery(this).val()]
        let nextQ = parent.next().attr('class')
        let nextChoice = choice + nextQ
        jQuery('.getting-started-suggestion').hide()
        parent.nextAll('li').find('input').removeAttr('checked')
        parent.nextAll('li').hide()
        if (jQuery('#' + nextChoice).length > 0) {
            jQuery('#' + nextChoice).show()
            jQuery('html, body').animate({
                scrollTop: jQuery('#' + nextChoice).offset().top
            }, 500)
        } else {
            jQuery('.' + choice).show()
            jQuery('html, body').animate({
                scrollTop: jQuery('.' + choice).offset().top
            }, 500)
        }
    })
	// Adobe Launch - 11/2019
	if (isAdobeLaunch) {
		// Quiz initiated 
		var gettingStartedDetails = {
			"quizName":"getStarted"
		}
		jQuery('a.fancybox-getting-started').click(function() {
			_satellite.track("quiz.initiated", gettingStartedDetails);
		})
		// Build up object as quiz progresses
		jQuery('.not-sure-where-to-being-questionnaire input').click(function() {
			var question = jQuery(this).attr('id');
			var value = jQuery(this).attr('data-title');
			gettingStartedDetails[question] = value;
		})
		// Quiz complete
		jQuery('.intLink').click(function() {
			var interiorLink = jQuery(this).attr('title');
			gettingStartedDetails["finalLink"] = interiorLink;
			_satellite.track("quiz.completed", gettingStartedDetails);
		})
	}
    if (!isTouchDevice()) {
        jQuery('a.fancybox-getting-started').fancybox({
            'margin': 0,
            'padding': 0,
            'speedIn': 500,
            'speedOut': 500,
            'titlePosition': 'over',
            'transitionIn': 'fade',
            'transitionOut': 'fade',
            'type': 'iframe',
            'scrolling': 'auto',
            'height': 400,
            'width': 700,
            'centerOnScroll': true,
            'onStart': function () {
                jQuery(document).scrollTop('0')
                jQuery('body').css({
                    'overflow': 'hidden'
                })
            },
            'onClosed': function () {
                jQuery('body').css({
                    'overflow': 'visible'
                })
            }
        })
    }

    let caseStudyFix = () => {
        if(document.querySelector('.case-study p') !== null) {
            replaceAllInstancesText(' percent ','% ','.case-study p')
        }
    }

    let flyoverSetup = function () {
        let topDiff = 13
        if (!isTouchDevice()) {
            let numFlyovers = 0
            jQuery('.flyover-link').each(function () {
                numFlyovers++

                if (jQuery(this).attr('rel')) {
                    let flyover = jQuery(this).attr('rel').toLowerCase()
                    if (!jQuery(this).next().is(flyover)) {
                        // Wrap the flyover link in a span tag so that we can
                        // position the pop-up relative to it on our desktop version
                        jQuery(this).wrap('<span class=\'flyover-link-wrap not-touch-device\'></span>')
                        if (numFlyovers >= 2) {
                            let flyoverCopy = jQuery(flyover).clone()
                            jQuery(this).parent().append(jQuery(flyoverCopy))
                        } else {
                            jQuery(this).parent().append(jQuery(flyover))
                        }
                        //jQuery(flyover).css("top", jQuery(this).position().top + topDiff);
                    }
                }
            })
            jQuery('.flyover-link').click(function (event) {
                event.preventDefault()
            })
        } else {
            // Reposition the popup top placement when a device's
            // orientation changes
            jQuery(window).on('orientationchange', function () {
                jQuery('.flyover-link').each(
                    function () {
                        let flyover = jQuery(this).attr('rel').toLowerCase()
                        jQuery(flyover).css('top', jQuery(this).position().top + topDiff)
                    }
                )
            })
            jQuery('.flyover-link').click(
                function () {
                    let iteration = jQuery(this).data('iteration') || 1
                    let flyover = ''
                    switch (iteration) {
                        case 1:
                            flyover = jQuery(this).attr('rel').toLowerCase()
                            if (!jQuery(this).next().is(flyover)) {
                                // Wrap the flyover link in a span tag so that we can
                                // position the pop-up relative to it on our desktop version
                                jQuery(this).wrap('<span class=\'flyover-link-wrap\'></span>')
                                jQuery(this).parent().append(jQuery(flyover))
                                jQuery(flyover).css('top', jQuery(this).position().top + topDiff)
                            }
                            jQuery(flyover).show()
                            break

                        case 2:
                            flyover = jQuery(this).attr('rel').toLowerCase()
                            jQuery(flyover).hide()
                            break
                    }
                    iteration++
                    if (iteration > 2) iteration = 1
                    jQuery(this).data('iteration', iteration)
                })

            // When the screen is touched let's check to see if we've clicked on
            // a flyover link and open it. If not, then we'll cycle through all
            // flyovers and close them. - JK
            // -----------------------------------------------------------------------------
            let dragging = false
            jQuery(document).on('touchmove', function () {
                // If we're dragging then set the letiable to true so that
                // when we lift our finger the page knows that we don't
                // want to clear the flyovers, but move the page.
                dragging = true
            })

            jQuery(document).on('touchend', function (event) {
                if (dragging == false) {
                    // If we're not dragging and have clicked on something other than
                    // a flyover link then clear the flyovers
                    if (!jQuery(event.target).closest('.flyover-link-wrap').length) {
                        jQuery('.flyover-link').each(function () {
                            let flyover = jQuery(this).attr('rel').toLowerCase()
                            let iteration = jQuery(this).data('iteration')
                            if (iteration == 2) {
                                jQuery(flyover).hide()
                                jQuery(this).data('iteration', 1)
                            }
                        })
                    }
                } else {
                    // If we're dragging then leave the flyovers open but
                    // set the dragging letiable to false to set it up for
                    // the next check.
                    dragging = false
                }
            })
        }

    }

    globalFunctions.flyoverSetup = flyoverSetup

    // Add text to empty anchor tags to fix 508 compliance errors
    setTimeout(function () {
        jQuery('#fancybox-close').html('<span class=\'offscreen\'>Close</span>')
        jQuery('#fancybox-left-ico').html('<span class=\'offscreen\'>Left</span>')
        jQuery('#fancybox-right-ico').html('<span class=\'offscreen\'>Right</span>')
    }, 100)

    // Fix IGX glitch. IGX for some reason places "</textarea>" instead of
    // your textarea field whenever you check in the page. We can remove
    // this line of code once IGX comes up with a fix.
    jQuery('textarea').val('')
    //converts all static email addresses into hyperlinked email addresses
    //emailize();
    jQuery('body').linkify()
    caseStudyFix()
    addCGAClass()
})

jQuery(document).ready(function () {
    let getting_started = ''
    jQuery('.q1 input[type=\'radio\']').click(function () {
        getting_started = '1)' + jQuery(this).data('title')
    })
    jQuery('.q2 input[type=\'radio\']').click(function () {
        getting_started = getting_started + ' 2)' + jQuery(this).data('title')
    })
    // jQuery('.getting-started-suggestion a').click(function () {
	// 	if (isAdobeLaunch) {

	// 	}
    // })

    if (document.querySelector('.reg-toggle-container')) {
        jQuery('.reg-toggle-box').attr('role', 'button').attr('tabindex', '0')
        jQuery('.reg-content').attr('aria-expanded', 'false')

        let toggleCheck = event => {
            if(event instanceof KeyboardEvent && event.code !== 'Enter') return
            
            let element = event.currentTarget
            let $nextSibling = jQuery(element).next('.reg-content')
            let isVisible = $nextSibling.is(':visible')

            jQuery(element).children(`span.toggle-span`).text(isVisible ? '+' : '-')
            jQuery(element).toggleClass('stl-is-active')

            isVisible ?
                $nextSibling.slideUp().attr('aria-expanded', 'false')
                :
                $nextSibling.slideDown().attr('aria-expanded', 'true')
        }

        Array.from(document.querySelectorAll(`.reg-toggle-box`)).forEach( element => {
            element.addEventListener('click', toggleCheck)
            element.addEventListener('keypress', toggleCheck)
        })
    }
})

/* querystring functions for PEPC */
function paramExists(parameter) {
    //Get Query String from url
    let fullQString = window.location.search.substring(1)

    let paramCount = 0
    let queryStringComplete = '?'

    if (fullQString.length > 0) {
        //Split Query String into separate parameters
        let paramArray = fullQString.split('&')

        //Loop through params, check if parameter exists.
        for (let i = 0; i < paramArray.length; i++) {
            let currentParameter = paramArray[i].split('=')
            if (currentParameter[0] == parameter) { //Parameter already exists in current url
                return true
            }
        }
    }
    return false
}

function gup(param) {
    // eslint-disable-next-line no-useless-escape
    param = param.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]')
    let regexS = '[\\?&]' + param + '=([^&#]*)'
    let regex = new RegExp(regexS)
    let results = regex.exec(window.location.search)
    if (results == null)
        return ''
    else
        return decodeURIComponent(results[1].replace(/\+/g, ' '))
}

// A jQuery based placeholder polyfill http://www.jacklmoore.com/notes/form-placeholder-text/
jQuery(document).ready(function () {
    function add() {
        if (jQuery(this).val() === '') {
            jQuery(this).val(jQuery(this).attr('placeholder')).addClass('placeholder')
        }
    }

    function remove() {
        if (jQuery(this).val() === jQuery(this).attr('placeholder')) {
            jQuery(this).val('').removeClass('placeholder')
        }
    }

    // Create a dummy element for feature detection
    if (!('placeholder' in jQuery('<input>')[0])) {

        // Select the elements that have a placeholder attribute
        jQuery('input[placeholder], textarea[placeholder]').blur(add).focus(remove).each(add)

        // Remove the placeholder text before the form is submitted
        jQuery('form').submit(function () {
            jQuery(this).find('input[placeholder], textarea[placeholder]').each(remove)
        })
    }

    // Unwrap script tags from IGX generated <p> tags
    jQuery('script').each(function () {
        if (jQuery(this).parent().is('p') && jQuery(this).parent().children().size() == 1) {
            jQuery(this).unwrap()
        }
    })

    // Toggle Plus/Minus for collapsable elements
    jQuery('a[data-toggle=\'collapse\']').each(function () {
        jQuery(this).on('click', function () {
            let icon = jQuery(this).children('span.glyphicon')
            let plusIcon = jQuery(this).children('span.glyphicon-plus-sign')
            let minusIcon = jQuery(this).children('span.glyphicon-minus-sign')

            if (plusIcon.length) {
                icon.removeClass('glyphicon-plus-sign').addClass('glyphicon-minus-sign')
            } else if (minusIcon.length) {
                icon.addClass('glyphicon-plus-sign').removeClass('glyphicon-minus-sign')
            }
        })
    })

    jQuery('.navbar-brand').click(function () {
        jQuery(this).parent().find('button').click()
        return false
    })

    // Give each journey section a unique class based on the visible button text. For example, the section giving amount would
    // have the class .giving-amount-wrap applied to it.
    jQuery('.journey-main .stl-col.stl-w-04 .stl-button').each(function () {
        jQuery(this).parents('div.stl-col.stl-w-04').addClass(jQuery(this).text().toLowerCase().replace(/\s+/, '-') + '-wrap')
    })

    // Capitalize the letters IRA in the Journey 70+ popup box
    let $iraLink = jQuery('.stl-white-popup a:contains("IRA")')
    if ($iraLink.length) {
        $iraLink.html($iraLink.html().replace(/ira/i, '<span class="force-upper">IRA</span>'))
    }

    //Adds captions to all videos based on their title
    try {
        let video = document.getElementById('stl-video-tag')
        if (video) {
            // sourceURI contains leading /
            let sourceURI = video.src.slice(video.src.lastIndexOf('/'), video.src.lastIndexOf('.'))
            // assetDirectory does NOT contain trailing /
            let assetDirectory = window.serverIs == 'preview' ? '/DSSPreview/Media/Stelter/global/videos/captions' : 'Media/Stelter/global/videos/captions'
            if(document.querySelector('#stl-video-tag track') == null){
                let track = document.createElement('track')
                track.kind = 'captions'
                track.label = 'English'
                track.srclang = 'en'
                track.src = assetDirectory + sourceURI + '.en.vtt'
                video.appendChild(track)
            }
        }
    } catch (error) {
        window.log ? window.log += '\n' + error : window.log = error
    }

    // Removes download button if displayed
    try {
        let video = document.getElementById('stl-video-tag')
        if (video) {
            video.controlsList = 'nodownload'
        }
    } catch (error) {
        window.log ? window.log += `\n${error}` : window.log = error
    }

})

jQuery(window).on("load",function () {
    // add the disclaimer code
    interactiveBrochuresUpdate()

    // Gift Illustrator letiable replacement
    if (jQuery('.GIfeature').length) {
        jQuery('a:contains("@[pgc-container]")').attr('href', '#pgc-container')
    }

    jQuery('.contactEMAddr').on('click', function (e) {
        e.preventDefault()
        let uname = jQuery(this).data('uname').trim()
        let domain = jQuery(this).data('domain').trim()
        let email = 'mailto:' + uname + '@' + domain
        window.location.href = email
    })

    if (window.serverIs == 'live' && document.querySelector('a[href*=xml]') !== null) {
        let brokenXmlLinks = Array.from(document.querySelectorAll('a[href*=xml]'))
        brokenXmlLinks.forEach(function (link) {
            if (link.innerText.includes('IRA')) {
                link.href = '/ira-charitable-rollover'
            } else {
                // eslint-disable-next-line no-console
                console.log(link)
            }
        })
    }

    globalFunctions.flyoverSetup()
    // 508 fix for missing recaptcha form name
    jQuery('.g-recaptcha-response').attr('aria-label', 'recaptcha response')
})

jQuery(document).ready(function () {
    if (jQuery('.GIfeature').length) {
        jQuery('a:contains("@[pgc-container]")').attr('href', '#pgc-container')
    }

    jQuery('.popup-with-zoom-anim').magnificPopup({
        type: 'inline',

        fixedContentPos: false,
        fixedBgPos: true,

        overflowY: 'auto',

        closeBtnInside: true,
        preloader: false,

        midClick: true,
        removalDelay: 300,
        mainClass: 'my-mfp-zoom-in'
    })

})